/**
 * @deprecated
 */
import $ from 'jquery';

require('./web/jquery.gm');

if ($('.js_map-filter').length) {
  $('.js_map-filter').ready(() => {
    $(window).on('load resize', () => {
      if (window.innerWidth < 768) {
        document.getElementById('map-filter').classList.add('map-filter--hide');
      } else {
        document.getElementById('map-filter').classList.remove('map-filter--hide');
      }
    });
  });
}

$(document).on('click', '.js_map-filter', function (e) {
  e.preventDefault();
  this.parentElement.classList.toggle('map-filter--hide');
});

$.googlemap.setDefaults({
  mapOptions: {
    scrollwheel: false,
  },
  markerTypes: [
    {},
    {
      name: 'papir',
      icon: {
        url: '/img/google-map/markers/papir.png',
        size: new google.maps.Size(64, 32),
        origin: new google.maps.Point(0, 0),
        anchor: new google.maps.Point(32, 32),
      },
      shape: {
        coords: [0, 0, 64, 32],
        type: 'rect',
      },
    }, {
      name: 'plasty',
      icon: {
        url: '/img/google-map/markers/plasty.png',
        size: new google.maps.Size(64, 32),
        origin: new google.maps.Point(0, 0),
        anchor: new google.maps.Point(32, 32),
      },
      shape: {
        coords: [0, 0, 64, 32],
        type: 'rect',
      },
    }, {
      name: 'olej',
      icon: {
        url: '/img/google-map/markers/olej.png',
        size: new google.maps.Size(64, 32),
        origin: new google.maps.Point(0, 0),
        anchor: new google.maps.Point(32, 32),
      },
      shape: {
        coords: [0, 0, 64, 32],
        type: 'rect',
      },
    }, {
      name: 'kovy',
      icon: {
        url: '/img/google-map/markers/kovy.png',
        size: new google.maps.Size(64, 32),
        origin: new google.maps.Point(0, 0),
        anchor: new google.maps.Point(32, 32),
      },
      shape: {
        coords: [0, 0, 64, 32],
        type: 'rect',
      },
    }, {
      name: 'odevy',
      icon: {
        url: '/img/google-map/markers/odevy.png',
        size: new google.maps.Size(64, 32),
        origin: new google.maps.Point(0, 0),
        anchor: new google.maps.Point(32, 32),
      },
      shape: {
        coords: [0, 0, 64, 32],
        type: 'rect',
      },
    }, {
      name: 'bio',
      icon: {
        url: '/img/google-map/markers/bio.png',
        size: new google.maps.Size(64, 32),
        origin: new google.maps.Point(0, 0),
        anchor: new google.maps.Point(32, 32),
      },
      shape: {
        coords: [0, 0, 64, 32],
        type: 'rect',
      },
    }, {
      name: 'sklo',
      icon: {
        url: '/img/google-map/markers/sklo.png',
        size: new google.maps.Size(64, 32),
        origin: new google.maps.Point(0, 0),
        anchor: new google.maps.Point(32, 32),
      },
      shape: {
        coords: [0, 0, 64, 32],
        type: 'rect',
      },
    }, {
      name: 'elektro',
      icon: {
        url: '/img/google-map/markers/elektro.png',
        size: new google.maps.Size(64, 32),
        origin: new google.maps.Point(0, 0),
        anchor: new google.maps.Point(32, 32),
      },
      shape: {
        coords: [0, 0, 64, 32],
        type: 'rect',
      },
    }, {
      name: 'papir-plasty',
      icon: {
        url: '/img/google-map/markers/papir-plasty.png',
        size: new google.maps.Size(64, 32),
        origin: new google.maps.Point(0, 0),
        anchor: new google.maps.Point(32, 32),
      },
      shape: {
        coords: [0, 0, 64, 32],
        type: 'rect',
      },
    }, {
      name: 'papir-olej',
      icon: {
        url: '/img/google-map/markers/papir-olej.png',
        size: new google.maps.Size(64, 32),
        origin: new google.maps.Point(0, 0),
        anchor: new google.maps.Point(32, 32),
      },
      shape: {
        coords: [0, 0, 64, 32],
        type: 'rect',
      },
    }, {
      name: 'papir-kovy',
      icon: {
        url: '/img/google-map/markers/papir-kovy.png',
        size: new google.maps.Size(64, 32),
        origin: new google.maps.Point(0, 0),
        anchor: new google.maps.Point(32, 32),
      },
      shape: {
        coords: [0, 0, 64, 32],
        type: 'rect',
      },
    }, {
      name: 'papir-odevy',
      icon: {
        url: '/img/google-map/markers/papir-odevy.png',
        size: new google.maps.Size(64, 32),
        origin: new google.maps.Point(0, 0),
        anchor: new google.maps.Point(32, 32),
      },
      shape: {
        coords: [0, 0, 64, 32],
        type: 'rect',
      },
    }, {
      name: 'papir-bio',
      icon: {
        url: '/img/google-map/markers/papir-bio.png',
        size: new google.maps.Size(64, 32),
        origin: new google.maps.Point(0, 0),
        anchor: new google.maps.Point(32, 32),
      },
      shape: {
        coords: [0, 0, 64, 32],
        type: 'rect',
      },
    }, {
      name: 'papir-sklo',
      icon: {
        url: '/img/google-map/markers/papir-sklo.png',
        size: new google.maps.Size(64, 32),
        origin: new google.maps.Point(0, 0),
        anchor: new google.maps.Point(32, 32),
      },
      shape: {
        coords: [0, 0, 64, 32],
        type: 'rect',
      },
    }, {
      name: 'papir-elektro',
      icon: {
        url: '/img/google-map/markers/papir-elektro.png',
        size: new google.maps.Size(64, 32),
        origin: new google.maps.Point(0, 0),
        anchor: new google.maps.Point(32, 32),
      },
      shape: {
        coords: [0, 0, 64, 32],
        type: 'rect',
      },
    }, {
      name: 'plasty-olej',
      icon: {
        url: '/img/google-map/markers/plasty-olej.png',
        size: new google.maps.Size(64, 32),
        origin: new google.maps.Point(0, 0),
        anchor: new google.maps.Point(32, 32),
      },
      shape: {
        coords: [0, 0, 64, 32],
        type: 'rect',
      },
    }, {
      name: 'plasty-kovy',
      icon: {
        url: '/img/google-map/markers/plasty-kovy.png',
        size: new google.maps.Size(64, 32),
        origin: new google.maps.Point(0, 0),
        anchor: new google.maps.Point(32, 32),
      },
      shape: {
        coords: [0, 0, 64, 32],
        type: 'rect',
      },
    }, {
      name: 'plasty-odevy',
      icon: {
        url: '/img/google-map/markers/plasty-odevy.png',
        size: new google.maps.Size(64, 32),
        origin: new google.maps.Point(0, 0),
        anchor: new google.maps.Point(32, 32),
      },
      shape: {
        coords: [0, 0, 64, 32],
        type: 'rect',
      },
    }, {
      name: 'plasty-bio',
      icon: {
        url: '/img/google-map/markers/plasty-bio.png',
        size: new google.maps.Size(64, 32),
        origin: new google.maps.Point(0, 0),
        anchor: new google.maps.Point(32, 32),
      },
      shape: {
        coords: [0, 0, 64, 32],
        type: 'rect',
      },
    }, {
      name: 'plasty-sklo',
      icon: {
        url: '/img/google-map/markers/plasty-sklo.png',
        size: new google.maps.Size(64, 32),
        origin: new google.maps.Point(0, 0),
        anchor: new google.maps.Point(32, 32),
      },
      shape: {
        coords: [0, 0, 64, 32],
        type: 'rect',
      },
    }, {
      name: 'plasty-elektro',
      icon: {
        url: '/img/google-map/markers/plasty-elektro.png',
        size: new google.maps.Size(64, 32),
        origin: new google.maps.Point(0, 0),
        anchor: new google.maps.Point(32, 32),
      },
      shape: {
        coords: [0, 0, 64, 32],
        type: 'rect',
      },
    }, {
      name: 'olej-kovy',
      icon: {
        url: '/img/google-map/markers/olej-kovy.png',
        size: new google.maps.Size(64, 32),
        origin: new google.maps.Point(0, 0),
        anchor: new google.maps.Point(32, 32),
      },
      shape: {
        coords: [0, 0, 64, 32],
        type: 'rect',
      },
    }, {
      name: 'olej-odevy',
      icon: {
        url: '/img/google-map/markers/olej-odevy.png',
        size: new google.maps.Size(64, 32),
        origin: new google.maps.Point(0, 0),
        anchor: new google.maps.Point(32, 32),
      },
      shape: {
        coords: [0, 0, 64, 32],
        type: 'rect',
      },
    }, {
      name: 'olej-bio',
      icon: {
        url: '/img/google-map/markers/olej-bio.png',
        size: new google.maps.Size(64, 32),
        origin: new google.maps.Point(0, 0),
        anchor: new google.maps.Point(32, 32),
      },
      shape: {
        coords: [0, 0, 64, 32],
        type: 'rect',
      },
    }, {
      name: 'olej-sklo',
      icon: {
        url: '/img/google-map/markers/olej-sklo.png',
        size: new google.maps.Size(64, 32),
        origin: new google.maps.Point(0, 0),
        anchor: new google.maps.Point(32, 32),
      },
      shape: {
        coords: [0, 0, 64, 32],
        type: 'rect',
      },
    }, {
      name: 'olej-elektro',
      icon: {
        url: '/img/google-map/markers/olej-elektro.png',
        size: new google.maps.Size(64, 32),
        origin: new google.maps.Point(0, 0),
        anchor: new google.maps.Point(32, 32),
      },
      shape: {
        coords: [0, 0, 64, 32],
        type: 'rect',
      },
    }, {
      name: 'kovy-odevy',
      icon: {
        url: '/img/google-map/markers/kovy-odevy.png',
        size: new google.maps.Size(64, 32),
        origin: new google.maps.Point(0, 0),
        anchor: new google.maps.Point(32, 32),
      },
      shape: {
        coords: [0, 0, 64, 32],
        type: 'rect',
      },
    }, {
      name: 'kovy-bio',
      icon: {
        url: '/img/google-map/markers/kovy-bio.png',
        size: new google.maps.Size(64, 32),
        origin: new google.maps.Point(0, 0),
        anchor: new google.maps.Point(32, 32),
      },
      shape: {
        coords: [0, 0, 64, 32],
        type: 'rect',
      },
    }, {
      name: 'kovy-sklo',
      icon: {
        url: '/img/google-map/markers/kovy-sklo.png',
        size: new google.maps.Size(64, 32),
        origin: new google.maps.Point(0, 0),
        anchor: new google.maps.Point(32, 32),
      },
      shape: {
        coords: [0, 0, 64, 32],
        type: 'rect',
      },
    }, {
      name: 'kovy-elektro',
      icon: {
        url: '/img/google-map/markers/kovy-elektro.png',
        size: new google.maps.Size(64, 32),
        origin: new google.maps.Point(0, 0),
        anchor: new google.maps.Point(32, 32),
      },
      shape: {
        coords: [0, 0, 64, 32],
        type: 'rect',
      },
    }, {
      name: 'odevy-bio',
      icon: {
        url: '/img/google-map/markers/odevy-bio.png',
        size: new google.maps.Size(64, 32),
        origin: new google.maps.Point(0, 0),
        anchor: new google.maps.Point(32, 32),
      },
      shape: {
        coords: [0, 0, 64, 32],
        type: 'rect',
      },
    }, {
      name: 'odevy-sklo',
      icon: {
        url: '/img/google-map/markers/odevy-sklo.png',
        size: new google.maps.Size(64, 32),
        origin: new google.maps.Point(0, 0),
        anchor: new google.maps.Point(32, 32),
      },
      shape: {
        coords: [0, 0, 64, 32],
        type: 'rect',
      },
    }, {
      name: 'odevy-elektro',
      icon: {
        url: '/img/google-map/markers/odevy-elektro.png',
        size: new google.maps.Size(64, 32),
        origin: new google.maps.Point(0, 0),
        anchor: new google.maps.Point(32, 32),
      },
      shape: {
        coords: [0, 0, 64, 32],
        type: 'rect',
      },
    }, {
      name: 'bio-sklo',
      icon: {
        url: '/img/google-map/markers/bio-sklo.png',
        size: new google.maps.Size(64, 32),
        origin: new google.maps.Point(0, 0),
        anchor: new google.maps.Point(32, 32),
      },
      shape: {
        coords: [0, 0, 64, 32],
        type: 'rect',
      },
    }, {
      name: 'bio-elektro',
      icon: {
        url: '/img/google-map/markers/bio-elektro.png',
        size: new google.maps.Size(64, 32),
        origin: new google.maps.Point(0, 0),
        anchor: new google.maps.Point(32, 32),
      },
      shape: {
        coords: [0, 0, 64, 32],
        type: 'rect',
      },
    }, {
      name: 'sklo-elektro',
      icon: {
        url: '/img/google-map/markers/sklo-elektro.png',
        size: new google.maps.Size(64, 32),
        origin: new google.maps.Point(0, 0),
        anchor: new google.maps.Point(32, 32),
      },
      shape: {
        coords: [0, 0, 64, 32],
        type: 'rect',
      },
    }, {
      name: 'papir-plasty-olej',
      icon: {
        url: '/img/google-map/markers/papir-plasty-olej.png',
        size: new google.maps.Size(64, 32),
        origin: new google.maps.Point(0, 0),
        anchor: new google.maps.Point(32, 32),
      },
      shape: {
        coords: [0, 0, 64, 32],
        type: 'rect',
      },
    }, {
      name: 'papir-plasty-kovy',
      icon: {
        url: '/img/google-map/markers/papir-plasty-kovy.png',
        size: new google.maps.Size(64, 32),
        origin: new google.maps.Point(0, 0),
        anchor: new google.maps.Point(32, 32),
      },
      shape: {
        coords: [0, 0, 64, 32],
        type: 'rect',
      },
    }, {
      name: 'papir-plasty-odevy',
      icon: {
        url: '/img/google-map/markers/papir-plasty-odevy.png',
        size: new google.maps.Size(64, 32),
        origin: new google.maps.Point(0, 0),
        anchor: new google.maps.Point(32, 32),
      },
      shape: {
        coords: [0, 0, 64, 32],
        type: 'rect',
      },
    }, {
      name: 'papir-plasty-bio',
      icon: {
        url: '/img/google-map/markers/papir-plasty-bio.png',
        size: new google.maps.Size(64, 32),
        origin: new google.maps.Point(0, 0),
        anchor: new google.maps.Point(32, 32),
      },
      shape: {
        coords: [0, 0, 64, 32],
        type: 'rect',
      },
    }, {
      name: 'papir-plasty-sklo',
      icon: {
        url: '/img/google-map/markers/papir-plasty-sklo.png',
        size: new google.maps.Size(64, 32),
        origin: new google.maps.Point(0, 0),
        anchor: new google.maps.Point(32, 32),
      },
      shape: {
        coords: [0, 0, 64, 32],
        type: 'rect',
      },
    }, {
      name: 'papir-plasty-elektro',
      icon: {
        url: '/img/google-map/markers/papir-plasty-elektro.png',
        size: new google.maps.Size(64, 32),
        origin: new google.maps.Point(0, 0),
        anchor: new google.maps.Point(32, 32),
      },
      shape: {
        coords: [0, 0, 64, 32],
        type: 'rect',
      },
    }, {
      name: 'papir-olej-kovy',
      icon: {
        url: '/img/google-map/markers/papir-olej-kovy.png',
        size: new google.maps.Size(64, 32),
        origin: new google.maps.Point(0, 0),
        anchor: new google.maps.Point(32, 32),
      },
      shape: {
        coords: [0, 0, 64, 32],
        type: 'rect',
      },
    }, {
      name: 'papir-olej-odevy',
      icon: {
        url: '/img/google-map/markers/papir-olej-odevy.png',
        size: new google.maps.Size(64, 32),
        origin: new google.maps.Point(0, 0),
        anchor: new google.maps.Point(32, 32),
      },
      shape: {
        coords: [0, 0, 64, 32],
        type: 'rect',
      },
    }, {
      name: 'papir-olej-bio',
      icon: {
        url: '/img/google-map/markers/papir-olej-bio.png',
        size: new google.maps.Size(64, 32),
        origin: new google.maps.Point(0, 0),
        anchor: new google.maps.Point(32, 32),
      },
      shape: {
        coords: [0, 0, 64, 32],
        type: 'rect',
      },
    }, {
      name: 'papir-olej-sklo',
      icon: {
        url: '/img/google-map/markers/papir-olej-sklo.png',
        size: new google.maps.Size(64, 32),
        origin: new google.maps.Point(0, 0),
        anchor: new google.maps.Point(32, 32),
      },
      shape: {
        coords: [0, 0, 64, 32],
        type: 'rect',
      },
    }, {
      name: 'papir-olej-elektro',
      icon: {
        url: '/img/google-map/markers/papir-olej-elektro.png',
        size: new google.maps.Size(64, 32),
        origin: new google.maps.Point(0, 0),
        anchor: new google.maps.Point(32, 32),
      },
      shape: {
        coords: [0, 0, 64, 32],
        type: 'rect',
      },
    }, {
      name: 'papir-kovy-odevy',
      icon: {
        url: '/img/google-map/markers/papir-kovy-odevy.png',
        size: new google.maps.Size(64, 32),
        origin: new google.maps.Point(0, 0),
        anchor: new google.maps.Point(32, 32),
      },
      shape: {
        coords: [0, 0, 64, 32],
        type: 'rect',
      },
    }, {
      name: 'papir-kovy-bio',
      icon: {
        url: '/img/google-map/markers/papir-kovy-bio.png',
        size: new google.maps.Size(64, 32),
        origin: new google.maps.Point(0, 0),
        anchor: new google.maps.Point(32, 32),
      },
      shape: {
        coords: [0, 0, 64, 32],
        type: 'rect',
      },
    }, {
      name: 'papir-kovy-sklo',
      icon: {
        url: '/img/google-map/markers/papir-kovy-sklo.png',
        size: new google.maps.Size(64, 32),
        origin: new google.maps.Point(0, 0),
        anchor: new google.maps.Point(32, 32),
      },
      shape: {
        coords: [0, 0, 64, 32],
        type: 'rect',
      },
    }, {
      name: 'papir-kovy-elektro',
      icon: {
        url: '/img/google-map/markers/papir-kovy-elektro.png',
        size: new google.maps.Size(64, 32),
        origin: new google.maps.Point(0, 0),
        anchor: new google.maps.Point(32, 32),
      },
      shape: {
        coords: [0, 0, 64, 32],
        type: 'rect',
      },
    }, {
      name: 'papir-odevy-bio',
      icon: {
        url: '/img/google-map/markers/papir-odevy-bio.png',
        size: new google.maps.Size(64, 32),
        origin: new google.maps.Point(0, 0),
        anchor: new google.maps.Point(32, 32),
      },
      shape: {
        coords: [0, 0, 64, 32],
        type: 'rect',
      },
    }, {
      name: 'papir-odevy-sklo',
      icon: {
        url: '/img/google-map/markers/papir-odevy-sklo.png',
        size: new google.maps.Size(64, 32),
        origin: new google.maps.Point(0, 0),
        anchor: new google.maps.Point(32, 32),
      },
      shape: {
        coords: [0, 0, 64, 32],
        type: 'rect',
      },
    }, {
      name: 'papir-odevy-elektro',
      icon: {
        url: '/img/google-map/markers/papir-odevy-elektro.png',
        size: new google.maps.Size(64, 32),
        origin: new google.maps.Point(0, 0),
        anchor: new google.maps.Point(32, 32),
      },
      shape: {
        coords: [0, 0, 64, 32],
        type: 'rect',
      },
    }, {
      name: 'papir-bio-sklo',
      icon: {
        url: '/img/google-map/markers/papir-bio-sklo.png',
        size: new google.maps.Size(64, 32),
        origin: new google.maps.Point(0, 0),
        anchor: new google.maps.Point(32, 32),
      },
      shape: {
        coords: [0, 0, 64, 32],
        type: 'rect',
      },
    }, {
      name: 'papir-bio-elektro',
      icon: {
        url: '/img/google-map/markers/papir-bio-elektro.png',
        size: new google.maps.Size(64, 32),
        origin: new google.maps.Point(0, 0),
        anchor: new google.maps.Point(32, 32),
      },
      shape: {
        coords: [0, 0, 64, 32],
        type: 'rect',
      },
    }, {
      name: 'papir-sklo-elektro',
      icon: {
        url: '/img/google-map/markers/papir-sklo-elektro.png',
        size: new google.maps.Size(64, 32),
        origin: new google.maps.Point(0, 0),
        anchor: new google.maps.Point(32, 32),
      },
      shape: {
        coords: [0, 0, 64, 32],
        type: 'rect',
      },
    }, {
      name: 'plasty-olej-kovy',
      icon: {
        url: '/img/google-map/markers/plasty-olej-kovy.png',
        size: new google.maps.Size(64, 32),
        origin: new google.maps.Point(0, 0),
        anchor: new google.maps.Point(32, 32),
      },
      shape: {
        coords: [0, 0, 64, 32],
        type: 'rect',
      },
    }, {
      name: 'plasty-olej-odevy',
      icon: {
        url: '/img/google-map/markers/plasty-olej-odevy.png',
        size: new google.maps.Size(64, 32),
        origin: new google.maps.Point(0, 0),
        anchor: new google.maps.Point(32, 32),
      },
      shape: {
        coords: [0, 0, 64, 32],
        type: 'rect',
      },
    }, {
      name: 'plasty-olej-bio',
      icon: {
        url: '/img/google-map/markers/plasty-olej-bio.png',
        size: new google.maps.Size(64, 32),
        origin: new google.maps.Point(0, 0),
        anchor: new google.maps.Point(32, 32),
      },
      shape: {
        coords: [0, 0, 64, 32],
        type: 'rect',
      },
    }, {
      name: 'plasty-olej-sklo',
      icon: {
        url: '/img/google-map/markers/plasty-olej-sklo.png',
        size: new google.maps.Size(64, 32),
        origin: new google.maps.Point(0, 0),
        anchor: new google.maps.Point(32, 32),
      },
      shape: {
        coords: [0, 0, 64, 32],
        type: 'rect',
      },
    }, {
      name: 'plasty-olej-elektro',
      icon: {
        url: '/img/google-map/markers/plasty-olej-elektro.png',
        size: new google.maps.Size(64, 32),
        origin: new google.maps.Point(0, 0),
        anchor: new google.maps.Point(32, 32),
      },
      shape: {
        coords: [0, 0, 64, 32],
        type: 'rect',
      },
    }, {
      name: 'plasty-kovy-odevy',
      icon: {
        url: '/img/google-map/markers/plasty-kovy-odevy.png',
        size: new google.maps.Size(64, 32),
        origin: new google.maps.Point(0, 0),
        anchor: new google.maps.Point(32, 32),
      },
      shape: {
        coords: [0, 0, 64, 32],
        type: 'rect',
      },
    }, {
      name: 'plasty-kovy-bio',
      icon: {
        url: '/img/google-map/markers/plasty-kovy-bio.png',
        size: new google.maps.Size(64, 32),
        origin: new google.maps.Point(0, 0),
        anchor: new google.maps.Point(32, 32),
      },
      shape: {
        coords: [0, 0, 64, 32],
        type: 'rect',
      },
    }, {
      name: 'plasty-kovy-sklo',
      icon: {
        url: '/img/google-map/markers/plasty-kovy-sklo.png',
        size: new google.maps.Size(64, 32),
        origin: new google.maps.Point(0, 0),
        anchor: new google.maps.Point(32, 32),
      },
      shape: {
        coords: [0, 0, 64, 32],
        type: 'rect',
      },
    }, {
      name: 'plasty-kovy-elektro',
      icon: {
        url: '/img/google-map/markers/plasty-kovy-elektro.png',
        size: new google.maps.Size(64, 32),
        origin: new google.maps.Point(0, 0),
        anchor: new google.maps.Point(32, 32),
      },
      shape: {
        coords: [0, 0, 64, 32],
        type: 'rect',
      },
    }, {
      name: 'plasty-odevy-bio',
      icon: {
        url: '/img/google-map/markers/plasty-odevy-bio.png',
        size: new google.maps.Size(64, 32),
        origin: new google.maps.Point(0, 0),
        anchor: new google.maps.Point(32, 32),
      },
      shape: {
        coords: [0, 0, 64, 32],
        type: 'rect',
      },
    }, {
      name: 'plasty-odevy-sklo',
      icon: {
        url: '/img/google-map/markers/plasty-odevy-sklo.png',
        size: new google.maps.Size(64, 32),
        origin: new google.maps.Point(0, 0),
        anchor: new google.maps.Point(32, 32),
      },
      shape: {
        coords: [0, 0, 64, 32],
        type: 'rect',
      },
    }, {
      name: 'plasty-odevy-elektro',
      icon: {
        url: '/img/google-map/markers/plasty-odevy-elektro.png',
        size: new google.maps.Size(64, 32),
        origin: new google.maps.Point(0, 0),
        anchor: new google.maps.Point(32, 32),
      },
      shape: {
        coords: [0, 0, 64, 32],
        type: 'rect',
      },
    }, {
      name: 'plasty-bio-sklo',
      icon: {
        url: '/img/google-map/markers/plasty-bio-sklo.png',
        size: new google.maps.Size(64, 32),
        origin: new google.maps.Point(0, 0),
        anchor: new google.maps.Point(32, 32),
      },
      shape: {
        coords: [0, 0, 64, 32],
        type: 'rect',
      },
    }, {
      name: 'plasty-bio-elektro',
      icon: {
        url: '/img/google-map/markers/plasty-bio-elektro.png',
        size: new google.maps.Size(64, 32),
        origin: new google.maps.Point(0, 0),
        anchor: new google.maps.Point(32, 32),
      },
      shape: {
        coords: [0, 0, 64, 32],
        type: 'rect',
      },
    }, {
      name: 'plasty-sklo-elektro',
      icon: {
        url: '/img/google-map/markers/plasty-sklo-elektro.png',
        size: new google.maps.Size(64, 32),
        origin: new google.maps.Point(0, 0),
        anchor: new google.maps.Point(32, 32),
      },
      shape: {
        coords: [0, 0, 64, 32],
        type: 'rect',
      },
    }, {
      name: 'olej-kovy-odevy',
      icon: {
        url: '/img/google-map/markers/olej-kovy-odevy.png',
        size: new google.maps.Size(64, 32),
        origin: new google.maps.Point(0, 0),
        anchor: new google.maps.Point(32, 32),
      },
      shape: {
        coords: [0, 0, 64, 32],
        type: 'rect',
      },
    }, {
      name: 'olej-kovy-bio',
      icon: {
        url: '/img/google-map/markers/olej-kovy-bio.png',
        size: new google.maps.Size(64, 32),
        origin: new google.maps.Point(0, 0),
        anchor: new google.maps.Point(32, 32),
      },
      shape: {
        coords: [0, 0, 64, 32],
        type: 'rect',
      },
    }, {
      name: 'olej-kovy-sklo',
      icon: {
        url: '/img/google-map/markers/olej-kovy-sklo.png',
        size: new google.maps.Size(64, 32),
        origin: new google.maps.Point(0, 0),
        anchor: new google.maps.Point(32, 32),
      },
      shape: {
        coords: [0, 0, 64, 32],
        type: 'rect',
      },
    }, {
      name: 'olej-kovy-elektro',
      icon: {
        url: '/img/google-map/markers/olej-kovy-elektro.png',
        size: new google.maps.Size(64, 32),
        origin: new google.maps.Point(0, 0),
        anchor: new google.maps.Point(32, 32),
      },
      shape: {
        coords: [0, 0, 64, 32],
        type: 'rect',
      },
    }, {
      name: 'olej-odevy-bio',
      icon: {
        url: '/img/google-map/markers/olej-odevy-bio.png',
        size: new google.maps.Size(64, 32),
        origin: new google.maps.Point(0, 0),
        anchor: new google.maps.Point(32, 32),
      },
      shape: {
        coords: [0, 0, 64, 32],
        type: 'rect',
      },
    }, {
      name: 'olej-odevy-sklo',
      icon: {
        url: '/img/google-map/markers/olej-odevy-sklo.png',
        size: new google.maps.Size(64, 32),
        origin: new google.maps.Point(0, 0),
        anchor: new google.maps.Point(32, 32),
      },
      shape: {
        coords: [0, 0, 64, 32],
        type: 'rect',
      },
    }, {
      name: 'olej-odevy-elektro',
      icon: {
        url: '/img/google-map/markers/olej-odevy-elektro.png',
        size: new google.maps.Size(64, 32),
        origin: new google.maps.Point(0, 0),
        anchor: new google.maps.Point(32, 32),
      },
      shape: {
        coords: [0, 0, 64, 32],
        type: 'rect',
      },
    }, {
      name: 'olej-bio-sklo',
      icon: {
        url: '/img/google-map/markers/olej-bio-sklo.png',
        size: new google.maps.Size(64, 32),
        origin: new google.maps.Point(0, 0),
        anchor: new google.maps.Point(32, 32),
      },
      shape: {
        coords: [0, 0, 64, 32],
        type: 'rect',
      },
    }, {
      name: 'olej-bio-elektro',
      icon: {
        url: '/img/google-map/markers/olej-bio-elektro.png',
        size: new google.maps.Size(64, 32),
        origin: new google.maps.Point(0, 0),
        anchor: new google.maps.Point(32, 32),
      },
      shape: {
        coords: [0, 0, 64, 32],
        type: 'rect',
      },
    }, {
      name: 'olej-sklo-elektro',
      icon: {
        url: '/img/google-map/markers/olej-sklo-elektro.png',
        size: new google.maps.Size(64, 32),
        origin: new google.maps.Point(0, 0),
        anchor: new google.maps.Point(32, 32),
      },
      shape: {
        coords: [0, 0, 64, 32],
        type: 'rect',
      },
    }, {
      name: 'kovy-odevy-bio',
      icon: {
        url: '/img/google-map/markers/kovy-odevy-bio.png',
        size: new google.maps.Size(64, 32),
        origin: new google.maps.Point(0, 0),
        anchor: new google.maps.Point(32, 32),
      },
      shape: {
        coords: [0, 0, 64, 32],
        type: 'rect',
      },
    }, {
      name: 'kovy-odevy-sklo',
      icon: {
        url: '/img/google-map/markers/kovy-odevy-sklo.png',
        size: new google.maps.Size(64, 32),
        origin: new google.maps.Point(0, 0),
        anchor: new google.maps.Point(32, 32),
      },
      shape: {
        coords: [0, 0, 64, 32],
        type: 'rect',
      },
    }, {
      name: 'kovy-odevy-elektro',
      icon: {
        url: '/img/google-map/markers/kovy-odevy-elektro.png',
        size: new google.maps.Size(64, 32),
        origin: new google.maps.Point(0, 0),
        anchor: new google.maps.Point(32, 32),
      },
      shape: {
        coords: [0, 0, 64, 32],
        type: 'rect',
      },
    }, {
      name: 'kovy-bio-sklo',
      icon: {
        url: '/img/google-map/markers/kovy-bio-sklo.png',
        size: new google.maps.Size(64, 32),
        origin: new google.maps.Point(0, 0),
        anchor: new google.maps.Point(32, 32),
      },
      shape: {
        coords: [0, 0, 64, 32],
        type: 'rect',
      },
    }, {
      name: 'kovy-bio-elektro',
      icon: {
        url: '/img/google-map/markers/kovy-bio-elektro.png',
        size: new google.maps.Size(64, 32),
        origin: new google.maps.Point(0, 0),
        anchor: new google.maps.Point(32, 32),
      },
      shape: {
        coords: [0, 0, 64, 32],
        type: 'rect',
      },
    }, {
      name: 'kovy-sklo-elektro',
      icon: {
        url: '/img/google-map/markers/kovy-sklo-elektro.png',
        size: new google.maps.Size(64, 32),
        origin: new google.maps.Point(0, 0),
        anchor: new google.maps.Point(32, 32),
      },
      shape: {
        coords: [0, 0, 64, 32],
        type: 'rect',
      },
    }, {
      name: 'odevy-bio-sklo',
      icon: {
        url: '/img/google-map/markers/odevy-bio-sklo.png',
        size: new google.maps.Size(64, 32),
        origin: new google.maps.Point(0, 0),
        anchor: new google.maps.Point(32, 32),
      },
      shape: {
        coords: [0, 0, 64, 32],
        type: 'rect',
      },
    }, {
      name: 'odevy-bio-elektro',
      icon: {
        url: '/img/google-map/markers/odevy-bio-elektro.png',
        size: new google.maps.Size(64, 32),
        origin: new google.maps.Point(0, 0),
        anchor: new google.maps.Point(32, 32),
      },
      shape: {
        coords: [0, 0, 64, 32],
        type: 'rect',
      },
    }, {
      name: 'odevy-sklo-elektro',
      icon: {
        url: '/img/google-map/markers/odevy-sklo-elektro.png',
        size: new google.maps.Size(64, 32),
        origin: new google.maps.Point(0, 0),
        anchor: new google.maps.Point(32, 32),
      },
      shape: {
        coords: [0, 0, 64, 32],
        type: 'rect',
      },
    }, {
      name: 'bio-sklo-elektro',
      icon: {
        url: '/img/google-map/markers/bio-sklo-elektro.png',
        size: new google.maps.Size(64, 32),
        origin: new google.maps.Point(0, 0),
        anchor: new google.maps.Point(32, 32),
      },
      shape: {
        coords: [0, 0, 64, 32],
        type: 'rect',
      },
    }, {
      name: 'papir-plasty-olej-kovy',
      icon: {
        url: '/img/google-map/markers/papir-plasty-olej-kovy.png',
        size: new google.maps.Size(64, 32),
        origin: new google.maps.Point(0, 0),
        anchor: new google.maps.Point(32, 32),
      },
      shape: {
        coords: [0, 0, 64, 32],
        type: 'rect',
      },
    }, {
      name: 'papir-plasty-olej-odevy',
      icon: {
        url: '/img/google-map/markers/papir-plasty-olej-odevy.png',
        size: new google.maps.Size(64, 32),
        origin: new google.maps.Point(0, 0),
        anchor: new google.maps.Point(32, 32),
      },
      shape: {
        coords: [0, 0, 64, 32],
        type: 'rect',
      },
    }, {
      name: 'papir-plasty-olej-bio',
      icon: {
        url: '/img/google-map/markers/papir-plasty-olej-bio.png',
        size: new google.maps.Size(64, 32),
        origin: new google.maps.Point(0, 0),
        anchor: new google.maps.Point(32, 32),
      },
      shape: {
        coords: [0, 0, 64, 32],
        type: 'rect',
      },
    }, {
      name: 'papir-plasty-olej-sklo',
      icon: {
        url: '/img/google-map/markers/papir-plasty-olej-sklo.png',
        size: new google.maps.Size(64, 32),
        origin: new google.maps.Point(0, 0),
        anchor: new google.maps.Point(32, 32),
      },
      shape: {
        coords: [0, 0, 64, 32],
        type: 'rect',
      },
    }, {
      name: 'papir-plasty-olej-elektro',
      icon: {
        url: '/img/google-map/markers/papir-plasty-olej-elektro.png',
        size: new google.maps.Size(64, 32),
        origin: new google.maps.Point(0, 0),
        anchor: new google.maps.Point(32, 32),
      },
      shape: {
        coords: [0, 0, 64, 32],
        type: 'rect',
      },
    }, {
      name: 'papir-plasty-kovy-odevy',
      icon: {
        url: '/img/google-map/markers/papir-plasty-kovy-odevy.png',
        size: new google.maps.Size(64, 32),
        origin: new google.maps.Point(0, 0),
        anchor: new google.maps.Point(32, 32),
      },
      shape: {
        coords: [0, 0, 64, 32],
        type: 'rect',
      },
    }, {
      name: 'papir-plasty-kovy-bio',
      icon: {
        url: '/img/google-map/markers/papir-plasty-kovy-bio.png',
        size: new google.maps.Size(64, 32),
        origin: new google.maps.Point(0, 0),
        anchor: new google.maps.Point(32, 32),
      },
      shape: {
        coords: [0, 0, 64, 32],
        type: 'rect',
      },
    }, {
      name: 'papir-plasty-kovy-sklo',
      icon: {
        url: '/img/google-map/markers/papir-plasty-kovy-sklo.png',
        size: new google.maps.Size(64, 32),
        origin: new google.maps.Point(0, 0),
        anchor: new google.maps.Point(32, 32),
      },
      shape: {
        coords: [0, 0, 64, 32],
        type: 'rect',
      },
    }, {
      name: 'papir-plasty-kovy-elektro',
      icon: {
        url: '/img/google-map/markers/papir-plasty-kovy-elektro.png',
        size: new google.maps.Size(64, 32),
        origin: new google.maps.Point(0, 0),
        anchor: new google.maps.Point(32, 32),
      },
      shape: {
        coords: [0, 0, 64, 32],
        type: 'rect',
      },
    }, {
      name: 'papir-plasty-odevy-bio',
      icon: {
        url: '/img/google-map/markers/papir-plasty-odevy-bio.png',
        size: new google.maps.Size(64, 32),
        origin: new google.maps.Point(0, 0),
        anchor: new google.maps.Point(32, 32),
      },
      shape: {
        coords: [0, 0, 64, 32],
        type: 'rect',
      },
    }, {
      name: 'papir-plasty-odevy-sklo',
      icon: {
        url: '/img/google-map/markers/papir-plasty-odevy-sklo.png',
        size: new google.maps.Size(64, 32),
        origin: new google.maps.Point(0, 0),
        anchor: new google.maps.Point(32, 32),
      },
      shape: {
        coords: [0, 0, 64, 32],
        type: 'rect',
      },
    }, {
      name: 'papir-plasty-odevy-elektro',
      icon: {
        url: '/img/google-map/markers/papir-plasty-odevy-elektro.png',
        size: new google.maps.Size(64, 32),
        origin: new google.maps.Point(0, 0),
        anchor: new google.maps.Point(32, 32),
      },
      shape: {
        coords: [0, 0, 64, 32],
        type: 'rect',
      },
    }, {
      name: 'papir-plasty-bio-sklo',
      icon: {
        url: '/img/google-map/markers/papir-plasty-bio-sklo.png',
        size: new google.maps.Size(64, 32),
        origin: new google.maps.Point(0, 0),
        anchor: new google.maps.Point(32, 32),
      },
      shape: {
        coords: [0, 0, 64, 32],
        type: 'rect',
      },
    }, {
      name: 'papir-plasty-bio-elektro',
      icon: {
        url: '/img/google-map/markers/papir-plasty-bio-elektro.png',
        size: new google.maps.Size(64, 32),
        origin: new google.maps.Point(0, 0),
        anchor: new google.maps.Point(32, 32),
      },
      shape: {
        coords: [0, 0, 64, 32],
        type: 'rect',
      },
    }, {
      name: 'papir-plasty-sklo-elektro',
      icon: {
        url: '/img/google-map/markers/papir-plasty-sklo-elektro.png',
        size: new google.maps.Size(64, 32),
        origin: new google.maps.Point(0, 0),
        anchor: new google.maps.Point(32, 32),
      },
      shape: {
        coords: [0, 0, 64, 32],
        type: 'rect',
      },
    }, {
      name: 'papir-olej-kovy-odevy',
      icon: {
        url: '/img/google-map/markers/papir-olej-kovy-odevy.png',
        size: new google.maps.Size(64, 32),
        origin: new google.maps.Point(0, 0),
        anchor: new google.maps.Point(32, 32),
      },
      shape: {
        coords: [0, 0, 64, 32],
        type: 'rect',
      },
    }, {
      name: 'papir-olej-kovy-bio',
      icon: {
        url: '/img/google-map/markers/papir-olej-kovy-bio.png',
        size: new google.maps.Size(64, 32),
        origin: new google.maps.Point(0, 0),
        anchor: new google.maps.Point(32, 32),
      },
      shape: {
        coords: [0, 0, 64, 32],
        type: 'rect',
      },
    }, {
      name: 'papir-olej-kovy-sklo',
      icon: {
        url: '/img/google-map/markers/papir-olej-kovy-sklo.png',
        size: new google.maps.Size(64, 32),
        origin: new google.maps.Point(0, 0),
        anchor: new google.maps.Point(32, 32),
      },
      shape: {
        coords: [0, 0, 64, 32],
        type: 'rect',
      },
    }, {
      name: 'papir-olej-kovy-elektro',
      icon: {
        url: '/img/google-map/markers/papir-olej-kovy-elektro.png',
        size: new google.maps.Size(64, 32),
        origin: new google.maps.Point(0, 0),
        anchor: new google.maps.Point(32, 32),
      },
      shape: {
        coords: [0, 0, 64, 32],
        type: 'rect',
      },
    }, {
      name: 'papir-olej-odevy-bio',
      icon: {
        url: '/img/google-map/markers/papir-olej-odevy-bio.png',
        size: new google.maps.Size(64, 32),
        origin: new google.maps.Point(0, 0),
        anchor: new google.maps.Point(32, 32),
      },
      shape: {
        coords: [0, 0, 64, 32],
        type: 'rect',
      },
    }, {
      name: 'papir-olej-odevy-sklo',
      icon: {
        url: '/img/google-map/markers/papir-olej-odevy-sklo.png',
        size: new google.maps.Size(64, 32),
        origin: new google.maps.Point(0, 0),
        anchor: new google.maps.Point(32, 32),
      },
      shape: {
        coords: [0, 0, 64, 32],
        type: 'rect',
      },
    }, {
      name: 'papir-olej-odevy-elektro',
      icon: {
        url: '/img/google-map/markers/papir-olej-odevy-elektro.png',
        size: new google.maps.Size(64, 32),
        origin: new google.maps.Point(0, 0),
        anchor: new google.maps.Point(32, 32),
      },
      shape: {
        coords: [0, 0, 64, 32],
        type: 'rect',
      },
    }, {
      name: 'papir-olej-bio-sklo',
      icon: {
        url: '/img/google-map/markers/papir-olej-bio-sklo.png',
        size: new google.maps.Size(64, 32),
        origin: new google.maps.Point(0, 0),
        anchor: new google.maps.Point(32, 32),
      },
      shape: {
        coords: [0, 0, 64, 32],
        type: 'rect',
      },
    }, {
      name: 'papir-olej-bio-elektro',
      icon: {
        url: '/img/google-map/markers/papir-olej-bio-elektro.png',
        size: new google.maps.Size(64, 32),
        origin: new google.maps.Point(0, 0),
        anchor: new google.maps.Point(32, 32),
      },
      shape: {
        coords: [0, 0, 64, 32],
        type: 'rect',
      },
    }, {
      name: 'papir-olej-sklo-elektro',
      icon: {
        url: '/img/google-map/markers/papir-olej-sklo-elektro.png',
        size: new google.maps.Size(64, 32),
        origin: new google.maps.Point(0, 0),
        anchor: new google.maps.Point(32, 32),
      },
      shape: {
        coords: [0, 0, 64, 32],
        type: 'rect',
      },
    }, {
      name: 'papir-kovy-odevy-bio',
      icon: {
        url: '/img/google-map/markers/papir-kovy-odevy-bio.png',
        size: new google.maps.Size(64, 32),
        origin: new google.maps.Point(0, 0),
        anchor: new google.maps.Point(32, 32),
      },
      shape: {
        coords: [0, 0, 64, 32],
        type: 'rect',
      },
    }, {
      name: 'papir-kovy-odevy-sklo',
      icon: {
        url: '/img/google-map/markers/papir-kovy-odevy-sklo.png',
        size: new google.maps.Size(64, 32),
        origin: new google.maps.Point(0, 0),
        anchor: new google.maps.Point(32, 32),
      },
      shape: {
        coords: [0, 0, 64, 32],
        type: 'rect',
      },
    }, {
      name: 'papir-kovy-odevy-elektro',
      icon: {
        url: '/img/google-map/markers/papir-kovy-odevy-elektro.png',
        size: new google.maps.Size(64, 32),
        origin: new google.maps.Point(0, 0),
        anchor: new google.maps.Point(32, 32),
      },
      shape: {
        coords: [0, 0, 64, 32],
        type: 'rect',
      },
    }, {
      name: 'papir-kovy-bio-sklo',
      icon: {
        url: '/img/google-map/markers/papir-kovy-bio-sklo.png',
        size: new google.maps.Size(64, 32),
        origin: new google.maps.Point(0, 0),
        anchor: new google.maps.Point(32, 32),
      },
      shape: {
        coords: [0, 0, 64, 32],
        type: 'rect',
      },
    }, {
      name: 'papir-kovy-bio-elektro',
      icon: {
        url: '/img/google-map/markers/papir-kovy-bio-elektro.png',
        size: new google.maps.Size(64, 32),
        origin: new google.maps.Point(0, 0),
        anchor: new google.maps.Point(32, 32),
      },
      shape: {
        coords: [0, 0, 64, 32],
        type: 'rect',
      },
    }, {
      name: 'papir-kovy-sklo-elektro',
      icon: {
        url: '/img/google-map/markers/papir-kovy-sklo-elektro.png',
        size: new google.maps.Size(64, 32),
        origin: new google.maps.Point(0, 0),
        anchor: new google.maps.Point(32, 32),
      },
      shape: {
        coords: [0, 0, 64, 32],
        type: 'rect',
      },
    }, {
      name: 'papir-odevy-bio-sklo',
      icon: {
        url: '/img/google-map/markers/papir-odevy-bio-sklo.png',
        size: new google.maps.Size(64, 32),
        origin: new google.maps.Point(0, 0),
        anchor: new google.maps.Point(32, 32),
      },
      shape: {
        coords: [0, 0, 64, 32],
        type: 'rect',
      },
    }, {
      name: 'papir-odevy-bio-elektro',
      icon: {
        url: '/img/google-map/markers/papir-odevy-bio-elektro.png',
        size: new google.maps.Size(64, 32),
        origin: new google.maps.Point(0, 0),
        anchor: new google.maps.Point(32, 32),
      },
      shape: {
        coords: [0, 0, 64, 32],
        type: 'rect',
      },
    }, {
      name: 'papir-odevy-sklo-elektro',
      icon: {
        url: '/img/google-map/markers/papir-odevy-sklo-elektro.png',
        size: new google.maps.Size(64, 32),
        origin: new google.maps.Point(0, 0),
        anchor: new google.maps.Point(32, 32),
      },
      shape: {
        coords: [0, 0, 64, 32],
        type: 'rect',
      },
    }, {
      name: 'papir-bio-sklo-elektro',
      icon: {
        url: '/img/google-map/markers/papir-bio-sklo-elektro.png',
        size: new google.maps.Size(64, 32),
        origin: new google.maps.Point(0, 0),
        anchor: new google.maps.Point(32, 32),
      },
      shape: {
        coords: [0, 0, 64, 32],
        type: 'rect',
      },
    }, {
      name: 'plasty-olej-kovy-odevy',
      icon: {
        url: '/img/google-map/markers/plasty-olej-kovy-odevy.png',
        size: new google.maps.Size(64, 32),
        origin: new google.maps.Point(0, 0),
        anchor: new google.maps.Point(32, 32),
      },
      shape: {
        coords: [0, 0, 64, 32],
        type: 'rect',
      },
    }, {
      name: 'plasty-olej-kovy-bio',
      icon: {
        url: '/img/google-map/markers/plasty-olej-kovy-bio.png',
        size: new google.maps.Size(64, 32),
        origin: new google.maps.Point(0, 0),
        anchor: new google.maps.Point(32, 32),
      },
      shape: {
        coords: [0, 0, 64, 32],
        type: 'rect',
      },
    }, {
      name: 'plasty-olej-kovy-sklo',
      icon: {
        url: '/img/google-map/markers/plasty-olej-kovy-sklo.png',
        size: new google.maps.Size(64, 32),
        origin: new google.maps.Point(0, 0),
        anchor: new google.maps.Point(32, 32),
      },
      shape: {
        coords: [0, 0, 64, 32],
        type: 'rect',
      },
    }, {
      name: 'plasty-olej-kovy-elektro',
      icon: {
        url: '/img/google-map/markers/plasty-olej-kovy-elektro.png',
        size: new google.maps.Size(64, 32),
        origin: new google.maps.Point(0, 0),
        anchor: new google.maps.Point(32, 32),
      },
      shape: {
        coords: [0, 0, 64, 32],
        type: 'rect',
      },
    }, {
      name: 'plasty-olej-odevy-bio',
      icon: {
        url: '/img/google-map/markers/plasty-olej-odevy-bio.png',
        size: new google.maps.Size(64, 32),
        origin: new google.maps.Point(0, 0),
        anchor: new google.maps.Point(32, 32),
      },
      shape: {
        coords: [0, 0, 64, 32],
        type: 'rect',
      },
    }, {
      name: 'plasty-olej-odevy-sklo',
      icon: {
        url: '/img/google-map/markers/plasty-olej-odevy-sklo.png',
        size: new google.maps.Size(64, 32),
        origin: new google.maps.Point(0, 0),
        anchor: new google.maps.Point(32, 32),
      },
      shape: {
        coords: [0, 0, 64, 32],
        type: 'rect',
      },
    }, {
      name: 'plasty-olej-odevy-elektro',
      icon: {
        url: '/img/google-map/markers/plasty-olej-odevy-elektro.png',
        size: new google.maps.Size(64, 32),
        origin: new google.maps.Point(0, 0),
        anchor: new google.maps.Point(32, 32),
      },
      shape: {
        coords: [0, 0, 64, 32],
        type: 'rect',
      },
    }, {
      name: 'plasty-olej-bio-sklo',
      icon: {
        url: '/img/google-map/markers/plasty-olej-bio-sklo.png',
        size: new google.maps.Size(64, 32),
        origin: new google.maps.Point(0, 0),
        anchor: new google.maps.Point(32, 32),
      },
      shape: {
        coords: [0, 0, 64, 32],
        type: 'rect',
      },
    }, {
      name: 'plasty-olej-bio-elektro',
      icon: {
        url: '/img/google-map/markers/plasty-olej-bio-elektro.png',
        size: new google.maps.Size(64, 32),
        origin: new google.maps.Point(0, 0),
        anchor: new google.maps.Point(32, 32),
      },
      shape: {
        coords: [0, 0, 64, 32],
        type: 'rect',
      },
    }, {
      name: 'plasty-olej-sklo-elektro',
      icon: {
        url: '/img/google-map/markers/plasty-olej-sklo-elektro.png',
        size: new google.maps.Size(64, 32),
        origin: new google.maps.Point(0, 0),
        anchor: new google.maps.Point(32, 32),
      },
      shape: {
        coords: [0, 0, 64, 32],
        type: 'rect',
      },
    }, {
      name: 'plasty-kovy-odevy-bio',
      icon: {
        url: '/img/google-map/markers/plasty-kovy-odevy-bio.png',
        size: new google.maps.Size(64, 32),
        origin: new google.maps.Point(0, 0),
        anchor: new google.maps.Point(32, 32),
      },
      shape: {
        coords: [0, 0, 64, 32],
        type: 'rect',
      },
    }, {
      name: 'plasty-kovy-odevy-sklo',
      icon: {
        url: '/img/google-map/markers/plasty-kovy-odevy-sklo.png',
        size: new google.maps.Size(64, 32),
        origin: new google.maps.Point(0, 0),
        anchor: new google.maps.Point(32, 32),
      },
      shape: {
        coords: [0, 0, 64, 32],
        type: 'rect',
      },
    }, {
      name: 'plasty-kovy-odevy-elektro',
      icon: {
        url: '/img/google-map/markers/plasty-kovy-odevy-elektro.png',
        size: new google.maps.Size(64, 32),
        origin: new google.maps.Point(0, 0),
        anchor: new google.maps.Point(32, 32),
      },
      shape: {
        coords: [0, 0, 64, 32],
        type: 'rect',
      },
    }, {
      name: 'plasty-kovy-bio-sklo',
      icon: {
        url: '/img/google-map/markers/plasty-kovy-bio-sklo.png',
        size: new google.maps.Size(64, 32),
        origin: new google.maps.Point(0, 0),
        anchor: new google.maps.Point(32, 32),
      },
      shape: {
        coords: [0, 0, 64, 32],
        type: 'rect',
      },
    }, {
      name: 'plasty-kovy-bio-elektro',
      icon: {
        url: '/img/google-map/markers/plasty-kovy-bio-elektro.png',
        size: new google.maps.Size(64, 32),
        origin: new google.maps.Point(0, 0),
        anchor: new google.maps.Point(32, 32),
      },
      shape: {
        coords: [0, 0, 64, 32],
        type: 'rect',
      },
    }, {
      name: 'plasty-kovy-sklo-elektro',
      icon: {
        url: '/img/google-map/markers/plasty-kovy-sklo-elektro.png',
        size: new google.maps.Size(64, 32),
        origin: new google.maps.Point(0, 0),
        anchor: new google.maps.Point(32, 32),
      },
      shape: {
        coords: [0, 0, 64, 32],
        type: 'rect',
      },
    }, {
      name: 'plasty-odevy-bio-sklo',
      icon: {
        url: '/img/google-map/markers/plasty-odevy-bio-sklo.png',
        size: new google.maps.Size(64, 32),
        origin: new google.maps.Point(0, 0),
        anchor: new google.maps.Point(32, 32),
      },
      shape: {
        coords: [0, 0, 64, 32],
        type: 'rect',
      },
    }, {
      name: 'plasty-odevy-bio-elektro',
      icon: {
        url: '/img/google-map/markers/plasty-odevy-bio-elektro.png',
        size: new google.maps.Size(64, 32),
        origin: new google.maps.Point(0, 0),
        anchor: new google.maps.Point(32, 32),
      },
      shape: {
        coords: [0, 0, 64, 32],
        type: 'rect',
      },
    }, {
      name: 'plasty-odevy-sklo-elektro',
      icon: {
        url: '/img/google-map/markers/plasty-odevy-sklo-elektro.png',
        size: new google.maps.Size(64, 32),
        origin: new google.maps.Point(0, 0),
        anchor: new google.maps.Point(32, 32),
      },
      shape: {
        coords: [0, 0, 64, 32],
        type: 'rect',
      },
    }, {
      name: 'plasty-bio-sklo-elektro',
      icon: {
        url: '/img/google-map/markers/plasty-bio-sklo-elektro.png',
        size: new google.maps.Size(64, 32),
        origin: new google.maps.Point(0, 0),
        anchor: new google.maps.Point(32, 32),
      },
      shape: {
        coords: [0, 0, 64, 32],
        type: 'rect',
      },
    }, {
      name: 'olej-kovy-odevy-bio',
      icon: {
        url: '/img/google-map/markers/olej-kovy-odevy-bio.png',
        size: new google.maps.Size(64, 32),
        origin: new google.maps.Point(0, 0),
        anchor: new google.maps.Point(32, 32),
      },
      shape: {
        coords: [0, 0, 64, 32],
        type: 'rect',
      },
    }, {
      name: 'olej-kovy-odevy-sklo',
      icon: {
        url: '/img/google-map/markers/olej-kovy-odevy-sklo.png',
        size: new google.maps.Size(64, 32),
        origin: new google.maps.Point(0, 0),
        anchor: new google.maps.Point(32, 32),
      },
      shape: {
        coords: [0, 0, 64, 32],
        type: 'rect',
      },
    }, {
      name: 'olej-kovy-odevy-elektro',
      icon: {
        url: '/img/google-map/markers/olej-kovy-odevy-elektro.png',
        size: new google.maps.Size(64, 32),
        origin: new google.maps.Point(0, 0),
        anchor: new google.maps.Point(32, 32),
      },
      shape: {
        coords: [0, 0, 64, 32],
        type: 'rect',
      },
    }, {
      name: 'olej-kovy-bio-sklo',
      icon: {
        url: '/img/google-map/markers/olej-kovy-bio-sklo.png',
        size: new google.maps.Size(64, 32),
        origin: new google.maps.Point(0, 0),
        anchor: new google.maps.Point(32, 32),
      },
      shape: {
        coords: [0, 0, 64, 32],
        type: 'rect',
      },
    }, {
      name: 'olej-kovy-bio-elektro',
      icon: {
        url: '/img/google-map/markers/olej-kovy-bio-elektro.png',
        size: new google.maps.Size(64, 32),
        origin: new google.maps.Point(0, 0),
        anchor: new google.maps.Point(32, 32),
      },
      shape: {
        coords: [0, 0, 64, 32],
        type: 'rect',
      },
    }, {
      name: 'olej-kovy-sklo-elektro',
      icon: {
        url: '/img/google-map/markers/olej-kovy-sklo-elektro.png',
        size: new google.maps.Size(64, 32),
        origin: new google.maps.Point(0, 0),
        anchor: new google.maps.Point(32, 32),
      },
      shape: {
        coords: [0, 0, 64, 32],
        type: 'rect',
      },
    }, {
      name: 'olej-odevy-bio-sklo',
      icon: {
        url: '/img/google-map/markers/olej-odevy-bio-sklo.png',
        size: new google.maps.Size(64, 32),
        origin: new google.maps.Point(0, 0),
        anchor: new google.maps.Point(32, 32),
      },
      shape: {
        coords: [0, 0, 64, 32],
        type: 'rect',
      },
    }, {
      name: 'olej-odevy-bio-elektro',
      icon: {
        url: '/img/google-map/markers/olej-odevy-bio-elektro.png',
        size: new google.maps.Size(64, 32),
        origin: new google.maps.Point(0, 0),
        anchor: new google.maps.Point(32, 32),
      },
      shape: {
        coords: [0, 0, 64, 32],
        type: 'rect',
      },
    }, {
      name: 'olej-odevy-sklo-elektro',
      icon: {
        url: '/img/google-map/markers/olej-odevy-sklo-elektro.png',
        size: new google.maps.Size(64, 32),
        origin: new google.maps.Point(0, 0),
        anchor: new google.maps.Point(32, 32),
      },
      shape: {
        coords: [0, 0, 64, 32],
        type: 'rect',
      },
    }, {
      name: 'olej-bio-sklo-elektro',
      icon: {
        url: '/img/google-map/markers/olej-bio-sklo-elektro.png',
        size: new google.maps.Size(64, 32),
        origin: new google.maps.Point(0, 0),
        anchor: new google.maps.Point(32, 32),
      },
      shape: {
        coords: [0, 0, 64, 32],
        type: 'rect',
      },
    }, {
      name: 'kovy-odevy-bio-sklo',
      icon: {
        url: '/img/google-map/markers/kovy-odevy-bio-sklo.png',
        size: new google.maps.Size(64, 32),
        origin: new google.maps.Point(0, 0),
        anchor: new google.maps.Point(32, 32),
      },
      shape: {
        coords: [0, 0, 64, 32],
        type: 'rect',
      },
    }, {
      name: 'kovy-odevy-bio-elektro',
      icon: {
        url: '/img/google-map/markers/kovy-odevy-bio-elektro.png',
        size: new google.maps.Size(64, 32),
        origin: new google.maps.Point(0, 0),
        anchor: new google.maps.Point(32, 32),
      },
      shape: {
        coords: [0, 0, 64, 32],
        type: 'rect',
      },
    }, {
      name: 'kovy-odevy-sklo-elektro',
      icon: {
        url: '/img/google-map/markers/kovy-odevy-sklo-elektro.png',
        size: new google.maps.Size(64, 32),
        origin: new google.maps.Point(0, 0),
        anchor: new google.maps.Point(32, 32),
      },
      shape: {
        coords: [0, 0, 64, 32],
        type: 'rect',
      },
    }, {
      name: 'kovy-bio-sklo-elektro',
      icon: {
        url: '/img/google-map/markers/kovy-bio-sklo-elektro.png',
        size: new google.maps.Size(64, 32),
        origin: new google.maps.Point(0, 0),
        anchor: new google.maps.Point(32, 32),
      },
      shape: {
        coords: [0, 0, 64, 32],
        type: 'rect',
      },
    }, {
      name: 'odevy-bio-sklo-elektro',
      icon: {
        url: '/img/google-map/markers/odevy-bio-sklo-elektro.png',
        size: new google.maps.Size(64, 32),
        origin: new google.maps.Point(0, 0),
        anchor: new google.maps.Point(32, 32),
      },
      shape: {
        coords: [0, 0, 64, 32],
        type: 'rect',
      },
    }, {
      name: 'papir-plasty-olej-kovy-odevy',
      icon: {
        url: '/img/google-map/markers/papir-plasty-olej-kovy-odevy.png',
        size: new google.maps.Size(64, 32),
        origin: new google.maps.Point(0, 0),
        anchor: new google.maps.Point(32, 32),
      },
      shape: {
        coords: [0, 0, 64, 32],
        type: 'rect',
      },
    }, {
      name: 'papir-plasty-olej-kovy-bio',
      icon: {
        url: '/img/google-map/markers/papir-plasty-olej-kovy-bio.png',
        size: new google.maps.Size(64, 32),
        origin: new google.maps.Point(0, 0),
        anchor: new google.maps.Point(32, 32),
      },
      shape: {
        coords: [0, 0, 64, 32],
        type: 'rect',
      },
    }, {
      name: 'papir-plasty-olej-kovy-sklo',
      icon: {
        url: '/img/google-map/markers/papir-plasty-olej-kovy-sklo.png',
        size: new google.maps.Size(64, 32),
        origin: new google.maps.Point(0, 0),
        anchor: new google.maps.Point(32, 32),
      },
      shape: {
        coords: [0, 0, 64, 32],
        type: 'rect',
      },
    }, {
      name: 'papir-plasty-olej-kovy-elektro',
      icon: {
        url: '/img/google-map/markers/papir-plasty-olej-kovy-elektro.png',
        size: new google.maps.Size(64, 32),
        origin: new google.maps.Point(0, 0),
        anchor: new google.maps.Point(32, 32),
      },
      shape: {
        coords: [0, 0, 64, 32],
        type: 'rect',
      },
    }, {
      name: 'papir-plasty-olej-odevy-bio',
      icon: {
        url: '/img/google-map/markers/papir-plasty-olej-odevy-bio.png',
        size: new google.maps.Size(64, 32),
        origin: new google.maps.Point(0, 0),
        anchor: new google.maps.Point(32, 32),
      },
      shape: {
        coords: [0, 0, 64, 32],
        type: 'rect',
      },
    }, {
      name: 'papir-plasty-olej-odevy-sklo',
      icon: {
        url: '/img/google-map/markers/papir-plasty-olej-odevy-sklo.png',
        size: new google.maps.Size(64, 32),
        origin: new google.maps.Point(0, 0),
        anchor: new google.maps.Point(32, 32),
      },
      shape: {
        coords: [0, 0, 64, 32],
        type: 'rect',
      },
    }, {
      name: 'papir-plasty-olej-odevy-elektro',
      icon: {
        url: '/img/google-map/markers/papir-plasty-olej-odevy-elektro.png',
        size: new google.maps.Size(64, 32),
        origin: new google.maps.Point(0, 0),
        anchor: new google.maps.Point(32, 32),
      },
      shape: {
        coords: [0, 0, 64, 32],
        type: 'rect',
      },
    }, {
      name: 'papir-plasty-olej-bio-sklo',
      icon: {
        url: '/img/google-map/markers/papir-plasty-olej-bio-sklo.png',
        size: new google.maps.Size(64, 32),
        origin: new google.maps.Point(0, 0),
        anchor: new google.maps.Point(32, 32),
      },
      shape: {
        coords: [0, 0, 64, 32],
        type: 'rect',
      },
    }, {
      name: 'papir-plasty-olej-bio-elektro',
      icon: {
        url: '/img/google-map/markers/papir-plasty-olej-bio-elektro.png',
        size: new google.maps.Size(64, 32),
        origin: new google.maps.Point(0, 0),
        anchor: new google.maps.Point(32, 32),
      },
      shape: {
        coords: [0, 0, 64, 32],
        type: 'rect',
      },
    }, {
      name: 'papir-plasty-olej-sklo-elektro',
      icon: {
        url: '/img/google-map/markers/papir-plasty-olej-sklo-elektro.png',
        size: new google.maps.Size(64, 32),
        origin: new google.maps.Point(0, 0),
        anchor: new google.maps.Point(32, 32),
      },
      shape: {
        coords: [0, 0, 64, 32],
        type: 'rect',
      },
    }, {
      name: 'papir-plasty-kovy-odevy-bio',
      icon: {
        url: '/img/google-map/markers/papir-plasty-kovy-odevy-bio.png',
        size: new google.maps.Size(64, 32),
        origin: new google.maps.Point(0, 0),
        anchor: new google.maps.Point(32, 32),
      },
      shape: {
        coords: [0, 0, 64, 32],
        type: 'rect',
      },
    }, {
      name: 'papir-plasty-kovy-odevy-sklo',
      icon: {
        url: '/img/google-map/markers/papir-plasty-kovy-odevy-sklo.png',
        size: new google.maps.Size(64, 32),
        origin: new google.maps.Point(0, 0),
        anchor: new google.maps.Point(32, 32),
      },
      shape: {
        coords: [0, 0, 64, 32],
        type: 'rect',
      },
    }, {
      name: 'papir-plasty-kovy-odevy-elektro',
      icon: {
        url: '/img/google-map/markers/papir-plasty-kovy-odevy-elektro.png',
        size: new google.maps.Size(64, 32),
        origin: new google.maps.Point(0, 0),
        anchor: new google.maps.Point(32, 32),
      },
      shape: {
        coords: [0, 0, 64, 32],
        type: 'rect',
      },
    }, {
      name: 'papir-plasty-kovy-bio-sklo',
      icon: {
        url: '/img/google-map/markers/papir-plasty-kovy-bio-sklo.png',
        size: new google.maps.Size(64, 32),
        origin: new google.maps.Point(0, 0),
        anchor: new google.maps.Point(32, 32),
      },
      shape: {
        coords: [0, 0, 64, 32],
        type: 'rect',
      },
    }, {
      name: 'papir-plasty-kovy-bio-elektro',
      icon: {
        url: '/img/google-map/markers/papir-plasty-kovy-bio-elektro.png',
        size: new google.maps.Size(64, 32),
        origin: new google.maps.Point(0, 0),
        anchor: new google.maps.Point(32, 32),
      },
      shape: {
        coords: [0, 0, 64, 32],
        type: 'rect',
      },
    }, {
      name: 'papir-plasty-kovy-sklo-elektro',
      icon: {
        url: '/img/google-map/markers/papir-plasty-kovy-sklo-elektro.png',
        size: new google.maps.Size(64, 32),
        origin: new google.maps.Point(0, 0),
        anchor: new google.maps.Point(32, 32),
      },
      shape: {
        coords: [0, 0, 64, 32],
        type: 'rect',
      },
    }, {
      name: 'papir-plasty-odevy-bio-sklo',
      icon: {
        url: '/img/google-map/markers/papir-plasty-odevy-bio-sklo.png',
        size: new google.maps.Size(64, 32),
        origin: new google.maps.Point(0, 0),
        anchor: new google.maps.Point(32, 32),
      },
      shape: {
        coords: [0, 0, 64, 32],
        type: 'rect',
      },
    }, {
      name: 'papir-plasty-odevy-bio-elektro',
      icon: {
        url: '/img/google-map/markers/papir-plasty-odevy-bio-elektro.png',
        size: new google.maps.Size(64, 32),
        origin: new google.maps.Point(0, 0),
        anchor: new google.maps.Point(32, 32),
      },
      shape: {
        coords: [0, 0, 64, 32],
        type: 'rect',
      },
    }, {
      name: 'papir-plasty-odevy-sklo-elektro',
      icon: {
        url: '/img/google-map/markers/papir-plasty-odevy-sklo-elektro.png',
        size: new google.maps.Size(64, 32),
        origin: new google.maps.Point(0, 0),
        anchor: new google.maps.Point(32, 32),
      },
      shape: {
        coords: [0, 0, 64, 32],
        type: 'rect',
      },
    }, {
      name: 'papir-plasty-bio-sklo-elektro',
      icon: {
        url: '/img/google-map/markers/papir-plasty-bio-sklo-elektro.png',
        size: new google.maps.Size(64, 32),
        origin: new google.maps.Point(0, 0),
        anchor: new google.maps.Point(32, 32),
      },
      shape: {
        coords: [0, 0, 64, 32],
        type: 'rect',
      },
    }, {
      name: 'papir-olej-kovy-odevy-bio',
      icon: {
        url: '/img/google-map/markers/papir-olej-kovy-odevy-bio.png',
        size: new google.maps.Size(64, 32),
        origin: new google.maps.Point(0, 0),
        anchor: new google.maps.Point(32, 32),
      },
      shape: {
        coords: [0, 0, 64, 32],
        type: 'rect',
      },
    }, {
      name: 'papir-olej-kovy-odevy-sklo',
      icon: {
        url: '/img/google-map/markers/papir-olej-kovy-odevy-sklo.png',
        size: new google.maps.Size(64, 32),
        origin: new google.maps.Point(0, 0),
        anchor: new google.maps.Point(32, 32),
      },
      shape: {
        coords: [0, 0, 64, 32],
        type: 'rect',
      },
    }, {
      name: 'papir-olej-kovy-odevy-elektro',
      icon: {
        url: '/img/google-map/markers/papir-olej-kovy-odevy-elektro.png',
        size: new google.maps.Size(64, 32),
        origin: new google.maps.Point(0, 0),
        anchor: new google.maps.Point(32, 32),
      },
      shape: {
        coords: [0, 0, 64, 32],
        type: 'rect',
      },
    }, {
      name: 'papir-olej-kovy-bio-sklo',
      icon: {
        url: '/img/google-map/markers/papir-olej-kovy-bio-sklo.png',
        size: new google.maps.Size(64, 32),
        origin: new google.maps.Point(0, 0),
        anchor: new google.maps.Point(32, 32),
      },
      shape: {
        coords: [0, 0, 64, 32],
        type: 'rect',
      },
    }, {
      name: 'papir-olej-kovy-bio-elektro',
      icon: {
        url: '/img/google-map/markers/papir-olej-kovy-bio-elektro.png',
        size: new google.maps.Size(64, 32),
        origin: new google.maps.Point(0, 0),
        anchor: new google.maps.Point(32, 32),
      },
      shape: {
        coords: [0, 0, 64, 32],
        type: 'rect',
      },
    }, {
      name: 'papir-olej-kovy-sklo-elektro',
      icon: {
        url: '/img/google-map/markers/papir-olej-kovy-sklo-elektro.png',
        size: new google.maps.Size(64, 32),
        origin: new google.maps.Point(0, 0),
        anchor: new google.maps.Point(32, 32),
      },
      shape: {
        coords: [0, 0, 64, 32],
        type: 'rect',
      },
    }, {
      name: 'papir-olej-odevy-bio-sklo',
      icon: {
        url: '/img/google-map/markers/papir-olej-odevy-bio-sklo.png',
        size: new google.maps.Size(64, 32),
        origin: new google.maps.Point(0, 0),
        anchor: new google.maps.Point(32, 32),
      },
      shape: {
        coords: [0, 0, 64, 32],
        type: 'rect',
      },
    }, {
      name: 'papir-olej-odevy-bio-elektro',
      icon: {
        url: '/img/google-map/markers/papir-olej-odevy-bio-elektro.png',
        size: new google.maps.Size(64, 32),
        origin: new google.maps.Point(0, 0),
        anchor: new google.maps.Point(32, 32),
      },
      shape: {
        coords: [0, 0, 64, 32],
        type: 'rect',
      },
    }, {
      name: 'papir-olej-odevy-sklo-elektro',
      icon: {
        url: '/img/google-map/markers/papir-olej-odevy-sklo-elektro.png',
        size: new google.maps.Size(64, 32),
        origin: new google.maps.Point(0, 0),
        anchor: new google.maps.Point(32, 32),
      },
      shape: {
        coords: [0, 0, 64, 32],
        type: 'rect',
      },
    }, {
      name: 'papir-olej-bio-sklo-elektro',
      icon: {
        url: '/img/google-map/markers/papir-olej-bio-sklo-elektro.png',
        size: new google.maps.Size(64, 32),
        origin: new google.maps.Point(0, 0),
        anchor: new google.maps.Point(32, 32),
      },
      shape: {
        coords: [0, 0, 64, 32],
        type: 'rect',
      },
    }, {
      name: 'papir-kovy-odevy-bio-sklo',
      icon: {
        url: '/img/google-map/markers/papir-kovy-odevy-bio-sklo.png',
        size: new google.maps.Size(64, 32),
        origin: new google.maps.Point(0, 0),
        anchor: new google.maps.Point(32, 32),
      },
      shape: {
        coords: [0, 0, 64, 32],
        type: 'rect',
      },
    }, {
      name: 'papir-kovy-odevy-bio-elektro',
      icon: {
        url: '/img/google-map/markers/papir-kovy-odevy-bio-elektro.png',
        size: new google.maps.Size(64, 32),
        origin: new google.maps.Point(0, 0),
        anchor: new google.maps.Point(32, 32),
      },
      shape: {
        coords: [0, 0, 64, 32],
        type: 'rect',
      },
    }, {
      name: 'papir-kovy-odevy-sklo-elektro',
      icon: {
        url: '/img/google-map/markers/papir-kovy-odevy-sklo-elektro.png',
        size: new google.maps.Size(64, 32),
        origin: new google.maps.Point(0, 0),
        anchor: new google.maps.Point(32, 32),
      },
      shape: {
        coords: [0, 0, 64, 32],
        type: 'rect',
      },
    }, {
      name: 'papir-kovy-bio-sklo-elektro',
      icon: {
        url: '/img/google-map/markers/papir-kovy-bio-sklo-elektro.png',
        size: new google.maps.Size(64, 32),
        origin: new google.maps.Point(0, 0),
        anchor: new google.maps.Point(32, 32),
      },
      shape: {
        coords: [0, 0, 64, 32],
        type: 'rect',
      },
    }, {
      name: 'papir-odevy-bio-sklo-elektro',
      icon: {
        url: '/img/google-map/markers/papir-odevy-bio-sklo-elektro.png',
        size: new google.maps.Size(64, 32),
        origin: new google.maps.Point(0, 0),
        anchor: new google.maps.Point(32, 32),
      },
      shape: {
        coords: [0, 0, 64, 32],
        type: 'rect',
      },
    }, {
      name: 'plasty-olej-kovy-odevy-bio',
      icon: {
        url: '/img/google-map/markers/plasty-olej-kovy-odevy-bio.png',
        size: new google.maps.Size(64, 32),
        origin: new google.maps.Point(0, 0),
        anchor: new google.maps.Point(32, 32),
      },
      shape: {
        coords: [0, 0, 64, 32],
        type: 'rect',
      },
    }, {
      name: 'plasty-olej-kovy-odevy-sklo',
      icon: {
        url: '/img/google-map/markers/plasty-olej-kovy-odevy-sklo.png',
        size: new google.maps.Size(64, 32),
        origin: new google.maps.Point(0, 0),
        anchor: new google.maps.Point(32, 32),
      },
      shape: {
        coords: [0, 0, 64, 32],
        type: 'rect',
      },
    }, {
      name: 'plasty-olej-kovy-odevy-elektro',
      icon: {
        url: '/img/google-map/markers/plasty-olej-kovy-odevy-elektro.png',
        size: new google.maps.Size(64, 32),
        origin: new google.maps.Point(0, 0),
        anchor: new google.maps.Point(32, 32),
      },
      shape: {
        coords: [0, 0, 64, 32],
        type: 'rect',
      },
    }, {
      name: 'plasty-olej-kovy-bio-sklo',
      icon: {
        url: '/img/google-map/markers/plasty-olej-kovy-bio-sklo.png',
        size: new google.maps.Size(64, 32),
        origin: new google.maps.Point(0, 0),
        anchor: new google.maps.Point(32, 32),
      },
      shape: {
        coords: [0, 0, 64, 32],
        type: 'rect',
      },
    }, {
      name: 'plasty-olej-kovy-bio-elektro',
      icon: {
        url: '/img/google-map/markers/plasty-olej-kovy-bio-elektro.png',
        size: new google.maps.Size(64, 32),
        origin: new google.maps.Point(0, 0),
        anchor: new google.maps.Point(32, 32),
      },
      shape: {
        coords: [0, 0, 64, 32],
        type: 'rect',
      },
    }, {
      name: 'plasty-olej-kovy-sklo-elektro',
      icon: {
        url: '/img/google-map/markers/plasty-olej-kovy-sklo-elektro.png',
        size: new google.maps.Size(64, 32),
        origin: new google.maps.Point(0, 0),
        anchor: new google.maps.Point(32, 32),
      },
      shape: {
        coords: [0, 0, 64, 32],
        type: 'rect',
      },
    }, {
      name: 'plasty-olej-odevy-bio-sklo',
      icon: {
        url: '/img/google-map/markers/plasty-olej-odevy-bio-sklo.png',
        size: new google.maps.Size(64, 32),
        origin: new google.maps.Point(0, 0),
        anchor: new google.maps.Point(32, 32),
      },
      shape: {
        coords: [0, 0, 64, 32],
        type: 'rect',
      },
    }, {
      name: 'plasty-olej-odevy-bio-elektro',
      icon: {
        url: '/img/google-map/markers/plasty-olej-odevy-bio-elektro.png',
        size: new google.maps.Size(64, 32),
        origin: new google.maps.Point(0, 0),
        anchor: new google.maps.Point(32, 32),
      },
      shape: {
        coords: [0, 0, 64, 32],
        type: 'rect',
      },
    }, {
      name: 'plasty-olej-odevy-sklo-elektro',
      icon: {
        url: '/img/google-map/markers/plasty-olej-odevy-sklo-elektro.png',
        size: new google.maps.Size(64, 32),
        origin: new google.maps.Point(0, 0),
        anchor: new google.maps.Point(32, 32),
      },
      shape: {
        coords: [0, 0, 64, 32],
        type: 'rect',
      },
    }, {
      name: 'plasty-olej-bio-sklo-elektro',
      icon: {
        url: '/img/google-map/markers/plasty-olej-bio-sklo-elektro.png',
        size: new google.maps.Size(64, 32),
        origin: new google.maps.Point(0, 0),
        anchor: new google.maps.Point(32, 32),
      },
      shape: {
        coords: [0, 0, 64, 32],
        type: 'rect',
      },
    }, {
      name: 'plasty-kovy-odevy-bio-sklo',
      icon: {
        url: '/img/google-map/markers/plasty-kovy-odevy-bio-sklo.png',
        size: new google.maps.Size(64, 32),
        origin: new google.maps.Point(0, 0),
        anchor: new google.maps.Point(32, 32),
      },
      shape: {
        coords: [0, 0, 64, 32],
        type: 'rect',
      },
    }, {
      name: 'plasty-kovy-odevy-bio-elektro',
      icon: {
        url: '/img/google-map/markers/plasty-kovy-odevy-bio-elektro.png',
        size: new google.maps.Size(64, 32),
        origin: new google.maps.Point(0, 0),
        anchor: new google.maps.Point(32, 32),
      },
      shape: {
        coords: [0, 0, 64, 32],
        type: 'rect',
      },
    }, {
      name: 'plasty-kovy-odevy-sklo-elektro',
      icon: {
        url: '/img/google-map/markers/plasty-kovy-odevy-sklo-elektro.png',
        size: new google.maps.Size(64, 32),
        origin: new google.maps.Point(0, 0),
        anchor: new google.maps.Point(32, 32),
      },
      shape: {
        coords: [0, 0, 64, 32],
        type: 'rect',
      },
    }, {
      name: 'plasty-kovy-bio-sklo-elektro',
      icon: {
        url: '/img/google-map/markers/plasty-kovy-bio-sklo-elektro.png',
        size: new google.maps.Size(64, 32),
        origin: new google.maps.Point(0, 0),
        anchor: new google.maps.Point(32, 32),
      },
      shape: {
        coords: [0, 0, 64, 32],
        type: 'rect',
      },
    }, {
      name: 'plasty-odevy-bio-sklo-elektro',
      icon: {
        url: '/img/google-map/markers/plasty-odevy-bio-sklo-elektro.png',
        size: new google.maps.Size(64, 32),
        origin: new google.maps.Point(0, 0),
        anchor: new google.maps.Point(32, 32),
      },
      shape: {
        coords: [0, 0, 64, 32],
        type: 'rect',
      },
    }, {
      name: 'olej-kovy-odevy-bio-sklo',
      icon: {
        url: '/img/google-map/markers/olej-kovy-odevy-bio-sklo.png',
        size: new google.maps.Size(64, 32),
        origin: new google.maps.Point(0, 0),
        anchor: new google.maps.Point(32, 32),
      },
      shape: {
        coords: [0, 0, 64, 32],
        type: 'rect',
      },
    }, {
      name: 'olej-kovy-odevy-bio-elektro',
      icon: {
        url: '/img/google-map/markers/olej-kovy-odevy-bio-elektro.png',
        size: new google.maps.Size(64, 32),
        origin: new google.maps.Point(0, 0),
        anchor: new google.maps.Point(32, 32),
      },
      shape: {
        coords: [0, 0, 64, 32],
        type: 'rect',
      },
    }, {
      name: 'olej-kovy-odevy-sklo-elektro',
      icon: {
        url: '/img/google-map/markers/olej-kovy-odevy-sklo-elektro.png',
        size: new google.maps.Size(64, 32),
        origin: new google.maps.Point(0, 0),
        anchor: new google.maps.Point(32, 32),
      },
      shape: {
        coords: [0, 0, 64, 32],
        type: 'rect',
      },
    }, {
      name: 'olej-kovy-bio-sklo-elektro',
      icon: {
        url: '/img/google-map/markers/olej-kovy-bio-sklo-elektro.png',
        size: new google.maps.Size(64, 32),
        origin: new google.maps.Point(0, 0),
        anchor: new google.maps.Point(32, 32),
      },
      shape: {
        coords: [0, 0, 64, 32],
        type: 'rect',
      },
    }, {
      name: 'olej-odevy-bio-sklo-elektro',
      icon: {
        url: '/img/google-map/markers/olej-odevy-bio-sklo-elektro.png',
        size: new google.maps.Size(64, 32),
        origin: new google.maps.Point(0, 0),
        anchor: new google.maps.Point(32, 32),
      },
      shape: {
        coords: [0, 0, 64, 32],
        type: 'rect',
      },
    }, {
      name: 'kovy-odevy-bio-sklo-elektro',
      icon: {
        url: '/img/google-map/markers/kovy-odevy-bio-sklo-elektro.png',
        size: new google.maps.Size(64, 32),
        origin: new google.maps.Point(0, 0),
        anchor: new google.maps.Point(32, 32),
      },
      shape: {
        coords: [0, 0, 64, 32],
        type: 'rect',
      },


    }, {
      name: 'papir-plasty-olej-kovy-odevy-bio',
      icon: {
        url: '/img/google-map/markers/papir-plasty-olej-kovy-odevy-bio.png',
        size: new google.maps.Size(64, 32),
        origin: new google.maps.Point(0, 0),
        anchor: new google.maps.Point(32, 32),
      },
      shape: {
        coords: [0, 0, 64, 32],
        type: 'rect',
      },
    }, {
      name: 'papir-plasty-olej-kovy-odevy-sklo',
      icon: {
        url: '/img/google-map/markers/papir-plasty-olej-kovy-odevy-sklo.png',
        size: new google.maps.Size(64, 32),
        origin: new google.maps.Point(0, 0),
        anchor: new google.maps.Point(32, 32),
      },
      shape: {
        coords: [0, 0, 64, 32],
        type: 'rect',
      },
    }, {
      name: 'papir-plasty-olej-kovy-odevy-elektro',
      icon: {
        url: '/img/google-map/markers/papir-plasty-olej-kovy-odevy-elektro.png',
        size: new google.maps.Size(64, 32),
        origin: new google.maps.Point(0, 0),
        anchor: new google.maps.Point(32, 32),
      },
      shape: {
        coords: [0, 0, 64, 32],
        type: 'rect',
      },
    }, {
      name: 'papir-plasty-olej-kovy-bio-sklo',
      icon: {
        url: '/img/google-map/markers/papir-plasty-olej-kovy-bio-sklo.png',
        size: new google.maps.Size(64, 32),
        origin: new google.maps.Point(0, 0),
        anchor: new google.maps.Point(32, 32),
      },
      shape: {
        coords: [0, 0, 64, 32],
        type: 'rect',
      },
    }, {
      name: 'papir-plasty-olej-kovy-bio-elektro',
      icon: {
        url: '/img/google-map/markers/papir-plasty-olej-kovy-bio-elektro.png',
        size: new google.maps.Size(64, 32),
        origin: new google.maps.Point(0, 0),
        anchor: new google.maps.Point(32, 32),
      },
      shape: {
        coords: [0, 0, 64, 32],
        type: 'rect',
      },
    }, {
      name: 'papir-plasty-olej-kovy-sklo-elektro',
      icon: {
        url: '/img/google-map/markers/papir-plasty-olej-kovy-sklo-elektro.png',
        size: new google.maps.Size(64, 32),
        origin: new google.maps.Point(0, 0),
        anchor: new google.maps.Point(32, 32),
      },
      shape: {
        coords: [0, 0, 64, 32],
        type: 'rect',
      },
    }, {
      name: 'papir-plasty-olej-odevy-bio-sklo',
      icon: {
        url: '/img/google-map/markers/papir-plasty-olej-odevy-bio-sklo.png',
        size: new google.maps.Size(64, 32),
        origin: new google.maps.Point(0, 0),
        anchor: new google.maps.Point(32, 32),
      },
      shape: {
        coords: [0, 0, 64, 32],
        type: 'rect',
      },
    }, {
      name: 'papir-plasty-olej-odevy-bio-elektro',
      icon: {
        url: '/img/google-map/markers/papir-plasty-olej-odevy-bio-elektro.png',
        size: new google.maps.Size(64, 32),
        origin: new google.maps.Point(0, 0),
        anchor: new google.maps.Point(32, 32),
      },
      shape: {
        coords: [0, 0, 64, 32],
        type: 'rect',
      },
    }, {
      name: 'papir-plasty-olej-odevy-sklo-elektro',
      icon: {
        url: '/img/google-map/markers/papir-plasty-olej-odevy-sklo-elektro.png',
        size: new google.maps.Size(64, 32),
        origin: new google.maps.Point(0, 0),
        anchor: new google.maps.Point(32, 32),
      },
      shape: {
        coords: [0, 0, 64, 32],
        type: 'rect',
      },
    }, {
      name: 'papir-plasty-olej-bio-sklo-elektro',
      icon: {
        url: '/img/google-map/markers/papir-plasty-olej-bio-sklo-elektro.png',
        size: new google.maps.Size(64, 32),
        origin: new google.maps.Point(0, 0),
        anchor: new google.maps.Point(32, 32),
      },
      shape: {
        coords: [0, 0, 64, 32],
        type: 'rect',
      },
    }, {
      name: 'papir-plasty-kovy-odevy-bio-sklo',
      icon: {
        url: '/img/google-map/markers/papir-plasty-kovy-odevy-bio-sklo.png',
        size: new google.maps.Size(64, 32),
        origin: new google.maps.Point(0, 0),
        anchor: new google.maps.Point(32, 32),
      },
      shape: {
        coords: [0, 0, 64, 32],
        type: 'rect',
      },
    }, {
      name: 'papir-plasty-kovy-odevy-bio-elektro',
      icon: {
        url: '/img/google-map/markers/papir-plasty-kovy-odevy-bio-elektro.png',
        size: new google.maps.Size(64, 32),
        origin: new google.maps.Point(0, 0),
        anchor: new google.maps.Point(32, 32),
      },
      shape: {
        coords: [0, 0, 64, 32],
        type: 'rect',
      },
    }, {
      name: 'papir-plasty-kovy-odevy-sklo-elektro',
      icon: {
        url: '/img/google-map/markers/papir-plasty-kovy-odevy-sklo-elektro.png',
        size: new google.maps.Size(64, 32),
        origin: new google.maps.Point(0, 0),
        anchor: new google.maps.Point(32, 32),
      },
      shape: {
        coords: [0, 0, 64, 32],
        type: 'rect',
      },
    }, {
      name: 'papir-plasty-kovy-bio-sklo-elektro',
      icon: {
        url: '/img/google-map/markers/papir-plasty-kovy-bio-sklo-elektro.png',
        size: new google.maps.Size(64, 32),
        origin: new google.maps.Point(0, 0),
        anchor: new google.maps.Point(32, 32),
      },
      shape: {
        coords: [0, 0, 64, 32],
        type: 'rect',
      },
    }, {
      name: 'papir-plasty-odevy-bio-sklo-elektro',
      icon: {
        url: '/img/google-map/markers/papir-plasty-odevy-bio-sklo-elektro.png',
        size: new google.maps.Size(64, 32),
        origin: new google.maps.Point(0, 0),
        anchor: new google.maps.Point(32, 32),
      },
      shape: {
        coords: [0, 0, 64, 32],
        type: 'rect',
      },
    }, {
      name: 'papir-olej-kovy-odevy-bio-sklo',
      icon: {
        url: '/img/google-map/markers/papir-olej-kovy-odevy-bio-sklo.png',
        size: new google.maps.Size(64, 32),
        origin: new google.maps.Point(0, 0),
        anchor: new google.maps.Point(32, 32),
      },
      shape: {
        coords: [0, 0, 64, 32],
        type: 'rect',
      },
    }, {
      name: 'papir-olej-kovy-odevy-bio-elektro',
      icon: {
        url: '/img/google-map/markers/papir-olej-kovy-odevy-bio-elektro.png',
        size: new google.maps.Size(64, 32),
        origin: new google.maps.Point(0, 0),
        anchor: new google.maps.Point(32, 32),
      },
      shape: {
        coords: [0, 0, 64, 32],
        type: 'rect',
      },
    }, {
      name: 'papir-olej-kovy-odevy-sklo-elektro',
      icon: {
        url: '/img/google-map/markers/papir-olej-kovy-odevy-sklo-elektro.png',
        size: new google.maps.Size(64, 32),
        origin: new google.maps.Point(0, 0),
        anchor: new google.maps.Point(32, 32),
      },
      shape: {
        coords: [0, 0, 64, 32],
        type: 'rect',
      },
    }, {
      name: 'papir-olej-kovy-bio-sklo-elektro',
      icon: {
        url: '/img/google-map/markers/papir-olej-kovy-bio-sklo-elektro.png',
        size: new google.maps.Size(64, 32),
        origin: new google.maps.Point(0, 0),
        anchor: new google.maps.Point(32, 32),
      },
      shape: {
        coords: [0, 0, 64, 32],
        type: 'rect',
      },
    }, {
      name: 'papir-olej-odevy-bio-sklo-elektro',
      icon: {
        url: '/img/google-map/markers/papir-olej-odevy-bio-sklo-elektro.png',
        size: new google.maps.Size(64, 32),
        origin: new google.maps.Point(0, 0),
        anchor: new google.maps.Point(32, 32),
      },
      shape: {
        coords: [0, 0, 64, 32],
        type: 'rect',
      },
    }, {
      name: 'papir-kovy-odevy-bio-sklo-elektro',
      icon: {
        url: '/img/google-map/markers/papir-kovy-odevy-bio-sklo-elektro.png',
        size: new google.maps.Size(64, 32),
        origin: new google.maps.Point(0, 0),
        anchor: new google.maps.Point(32, 32),
      },
      shape: {
        coords: [0, 0, 64, 32],
        type: 'rect',
      },
    }, {
      name: 'plasty-olej-kovy-odevy-bio-sklo',
      icon: {
        url: '/img/google-map/markers/plasty-olej-kovy-odevy-bio-sklo.png',
        size: new google.maps.Size(64, 32),
        origin: new google.maps.Point(0, 0),
        anchor: new google.maps.Point(32, 32),
      },
      shape: {
        coords: [0, 0, 64, 32],
        type: 'rect',
      },
    }, {
      name: 'plasty-olej-kovy-odevy-bio-elektro',
      icon: {
        url: '/img/google-map/markers/plasty-olej-kovy-odevy-bio-elektro.png',
        size: new google.maps.Size(64, 32),
        origin: new google.maps.Point(0, 0),
        anchor: new google.maps.Point(32, 32),
      },
      shape: {
        coords: [0, 0, 64, 32],
        type: 'rect',
      },
    }, {
      name: 'plasty-olej-kovy-odevy-sklo-elektro',
      icon: {
        url: '/img/google-map/markers/plasty-olej-kovy-odevy-sklo-elektro.png',
        size: new google.maps.Size(64, 32),
        origin: new google.maps.Point(0, 0),
        anchor: new google.maps.Point(32, 32),
      },
      shape: {
        coords: [0, 0, 64, 32],
        type: 'rect',
      },
    }, {
      name: 'plasty-olej-kovy-bio-sklo-elektro',
      icon: {
        url: '/img/google-map/markers/plasty-olej-kovy-bio-sklo-elektro.png',
        size: new google.maps.Size(64, 32),
        origin: new google.maps.Point(0, 0),
        anchor: new google.maps.Point(32, 32),
      },
      shape: {
        coords: [0, 0, 64, 32],
        type: 'rect',
      },
    }, {
      name: 'plasty-olej-odevy-bio-sklo-elektro',
      icon: {
        url: '/img/google-map/markers/plasty-olej-odevy-bio-sklo-elektro.png',
        size: new google.maps.Size(64, 32),
        origin: new google.maps.Point(0, 0),
        anchor: new google.maps.Point(32, 32),
      },
      shape: {
        coords: [0, 0, 64, 32],
        type: 'rect',
      },
    }, {
      name: 'plasty-kovy-odevy-bio-sklo-elektro',
      icon: {
        url: '/img/google-map/markers/plasty-kovy-odevy-bio-sklo-elektro.png',
        size: new google.maps.Size(64, 32),
        origin: new google.maps.Point(0, 0),
        anchor: new google.maps.Point(32, 32),
      },
      shape: {
        coords: [0, 0, 64, 32],
        type: 'rect',
      },
    }, {
      name: 'olej-kovy-odevy-bio-sklo-elektro',
      icon: {
        url: '/img/google-map/markers/olej-kovy-odevy-bio-sklo-elektro.png',
        size: new google.maps.Size(64, 32),
        origin: new google.maps.Point(0, 0),
        anchor: new google.maps.Point(32, 32),
      },
      shape: {
        coords: [0, 0, 64, 32],
        type: 'rect',
      },
    }, {
      name: 'papir-plasty-olej-kovy-odevy-bio-sklo',
      icon: {
        url: '/img/google-map/markers/papir-plasty-olej-kovy-odevy-bio-sklo.png',
        size: new google.maps.Size(64, 32),
        origin: new google.maps.Point(0, 0),
        anchor: new google.maps.Point(32, 32),
      },
      shape: {
        coords: [0, 0, 64, 32],
        type: 'rect',
      },
    }, {
      name: 'papir-plasty-olej-kovy-odevy-bio-elektro',
      icon: {
        url: '/img/google-map/markers/papir-plasty-olej-kovy-odevy-bio-elektro.png',
        size: new google.maps.Size(64, 32),
        origin: new google.maps.Point(0, 0),
        anchor: new google.maps.Point(32, 32),
      },
      shape: {
        coords: [0, 0, 64, 32],
        type: 'rect',
      },
    }, {
      name: 'papir-plasty-olej-kovy-odevy-sklo-elektro',
      icon: {
        url: '/img/google-map/markers/papir-plasty-olej-kovy-odevy-sklo-elektro.png',
        size: new google.maps.Size(64, 32),
        origin: new google.maps.Point(0, 0),
        anchor: new google.maps.Point(32, 32),
      },
      shape: {
        coords: [0, 0, 64, 32],
        type: 'rect',
      },
    }, {
      name: 'papir-plasty-olej-kovy-bio-sklo-elektro',
      icon: {
        url: '/img/google-map/markers/papir-plasty-olej-kovy-bio-sklo-elektro.png',
        size: new google.maps.Size(64, 32),
        origin: new google.maps.Point(0, 0),
        anchor: new google.maps.Point(32, 32),
      },
      shape: {
        coords: [0, 0, 64, 32],
        type: 'rect',
      },
    }, {
      name: 'papir-plasty-olej-odevy-bio-sklo-elektro',
      icon: {
        url: '/img/google-map/markers/papir-plasty-olej-odevy-bio-sklo-elektro.png',
        size: new google.maps.Size(64, 32),
        origin: new google.maps.Point(0, 0),
        anchor: new google.maps.Point(32, 32),
      },
      shape: {
        coords: [0, 0, 64, 32],
        type: 'rect',
      },
    }, {
      name: 'papir-plasty-kovy-odevy-bio-sklo-elektro',
      icon: {
        url: '/img/google-map/markers/papir-plasty-kovy-odevy-bio-sklo-elektro.png',
        size: new google.maps.Size(64, 32),
        origin: new google.maps.Point(0, 0),
        anchor: new google.maps.Point(32, 32),
      },
      shape: {
        coords: [0, 0, 64, 32],
        type: 'rect',
      },
    }, {
      name: 'papir-olej-kovy-odevy-bio-sklo-elektro',
      icon: {
        url: '/img/google-map/markers/papir-olej-kovy-odevy-bio-sklo-elektro.png',
        size: new google.maps.Size(64, 32),
        origin: new google.maps.Point(0, 0),
        anchor: new google.maps.Point(32, 32),
      },
      shape: {
        coords: [0, 0, 64, 32],
        type: 'rect',
      },
    }, {
      name: 'plasty-olej-kovy-odevy-bio-sklo-elektro',
      icon: {
        url: '/img/google-map/markers/plasty-olej-kovy-odevy-bio-sklo-elektro.png',
        size: new google.maps.Size(64, 32),
        origin: new google.maps.Point(0, 0),
        anchor: new google.maps.Point(32, 32),
      },
      shape: {
        coords: [0, 0, 64, 32],
        type: 'rect',
      },
    }, {
      name: 'papir-plasty-olej-kovy-odevy-bio-sklo-elektro',
      icon: {
        url: '/img/google-map/markers/papir-plasty-olej-kovy-odevy-bio-sklo-elektro.png',
        size: new google.maps.Size(64, 32),
        origin: new google.maps.Point(0, 0),
        anchor: new google.maps.Point(32, 32),
      },
      shape: {
        coords: [0, 0, 64, 32],
        type: 'rect',
      },
    },
  ],
  bubbleContentFormatter(mData) {
    let str = '';
    if (mData.shortDescription) {
      const $shortDescription = $(mData.shortDescription);

      str = $shortDescription.prop('outerHTML');
    }

    return str;
  },
  clustering: {
    enabled: false,
  },
});


/*
 * !!!NECHAT NA KONCI web.js!!!
 * V hlavičce webu je JavaScript var q = []; $ = function(f) {q.push(f)};, který zajistí,
 * že kdekoli vyskytující se inline javascript bude vykonán až po načtení stránky
 * Inline JavaScript musí být vnořen do následujícího kusu kódu
 *
 * $(function(){
 *     //inline JavaScript
 * });
 *
 * který je ve skutečnosti zkrácené volání $(document).ready() @see http://learn.jquery.com/using-jquery-core/document-ready/
 * předpokládá se tedy, že na webu bude použito jQuery
 *
 * viz http://www.slideshare.net/slideshow/embed_code/17116700?startSlide=10
 * */
if (window.q) {
  window.q.forEach((f) => {
    $(f);
  });
}



// WEBPACK FOOTER //
// ./fe/web-default/src/js/web.js